<template>
    <v-app-bar
        app
        clipped-left
        color="secondary"
        :dark="!$vuetify.theme.dark">
        <v-app-bar-title>
            <img
                class="app-title"
                src="../../assets/logo-andamanda.png"/>
        </v-app-bar-title>

        <v-spacer/>

        <div
            class="username pr-6 font-weight-light">
            {{ username }}
        </div>
        <v-btn
            text
            class="ml-2 font-weight-light"
            @click="logout">
            {{ $t('button.logout') }}
        </v-btn>
    </v-app-bar>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'TopMenuBar',

    computed: {
        ...mapState(['username'])
    },

    methods: {
        logout () {
            localStorage.clear()
            this.$router.push({
                name: 'Login'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-app-bar-title {
    .v-app-bar-title__placeholder {
        display: flex;
    }
}

.app-title {
    padding-bottom: 8px;
    width: 160px;
    height: auto;
}

.username {
    border-right: 2px solid;
}

</style>
